export enum Queries {
    // Auth queries - magic link implementation
    getCurrentUser = 'getCurrentUser',
    getUserMetadata = 'getUserMetadata',

    // HRIS queries
    getJobs = 'getJobs',
    hrisJobStatus = 'hrisJobStatus',
    hrisFieldMappings = 'hrisFieldMappings',
    hrisDetailedMappings = 'hrisDetailedMappings',
    hrisConfirmedMappings = 'hrisConfirmedMappings',
    hrisJobResults = 'hrisJobResults',
    hrisAuditTrail = 'hrisAuditTrail',
    hrisFieldMetadata = 'hrisFieldMetadata',

    // Notification queries
    getNotifications = 'getNotifications',
    getNotificationCount = 'getNotificationCount',

    // Notification Settings queries
    getNotificationSettings = 'getNotificationSettings',

    // Intake survey queries
    validateIntakeSurvey = 'validateIntakeSurvey',
    getManagerIntakeSurvey = 'getManagerIntakeSurvey',

    // HR Intake queries
    getHRIntakeFormQuestions = 'getHRIntakeFormQuestions',
    getHRIntakeFormSubmission = 'getHRIntakeFormSubmission',
    getHRIntakeFormProgress = 'getHRIntakeFormProgress',

    // Integration queries
    getIntegrationsSummary = 'getIntegrationsSummary',

    // Unified Onboarding queries
    onboardingStatus = 'onboardingStatus',

    // User Management queries
    listUsers = 'listUsers',
    getUserDetails = 'getUserDetails',
    getUserByEmail = 'getUserByEmail',
    getMyTeam = 'getMyTeam',
    getUserProfile = 'getUserProfile',

    // Hierarchy queries
    getOrganizationHierarchy = 'getOrganizationHierarchy',
    getHierarchyFilters = 'getHierarchyFilters',
}
